export default __webpack_public_path__ + "static/media/shahbaz.83f316de.png";